"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("hammerjs");
var core_1 = require("@angular/core");
var environment_1 = require("./environments/environment");
var Logger_1 = require("./app/Logger/Logger");
var __NgCli_bootstrap_1 = require("./app/app.module.ngfactory");
var __NgCli_bootstrap_2 = require("@angular/platform-browser");
function getBaseUrl() {
    var url = document.getElementsByTagName("base")[0].href;
    url = url.endsWith("/") ? url.substr(0, url.length - 1) : url;
    return url;
}
exports.getBaseUrl = getBaseUrl;
var providers = [{ provide: "BASE_URL", useFactory: getBaseUrl, deps: [] }];
if (environment_1.environment.production) {
    core_1.enableProdMode();
    Logger_1.LoggerInit(Logger_1.LoggerLevel.ERROR);
}
else {
    Logger_1.LoggerInit(Logger_1.LoggerLevel.DEBUG);
}
var bootstrap = function () {
    __NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory).catch(function (err) { return console.log(err); });
};
var ɵ0 = bootstrap;
exports.ɵ0 = ɵ0;
if (typeof window['cordova'] !== 'undefined') {
    document.addEventListener('deviceready', function () {
        bootstrap();
        // (<any>window).cordova.InAppBrowser.addEventListener("loadstart", (evt) => {
        //   console.log(">>>>>>>>>>>>>>>>>>>");
        //   console.log(evt);
        // });
        var oldOpen = window.cordova.InAppBrowser.open;
        window.cordova.InAppBrowser.open = function (url, target, options) {
            if (!url.includes("localhost")) {
                return oldOpen(url, "_system", options);
            }
            else
                return oldOpen(url, target, options);
        };
        window.handleOpenURL = function (url) {
            console.log(">>>>>>>>>>>>>>>>>>>");
            // do stuff, for example
            // document.getElementById("url").value = url;
            console.log(url);
        };
    }, false);
}
else {
    bootstrap();
}
// platformBrowserDynamic(providers)
//   .bootstrapModule(AppModule)
//   .catch(err => console.log(err));
// if (environment.name == "CORDOVA") {
//   let onDeviceReady = () => {
//     console.log('on ready');
//     platformBrowserDynamic(providers).bootstrapModule(AppModule)
//   };
//   console.log('on cordova');
//   document.addEventListener('deviceready', onDeviceReady, false);
// } else {
//   console.log('no cordova');
//   platformBrowserDynamic(providers)
//     .bootstrapModule(AppModule)
//     .catch(err => console.log(err));
// }
